var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppPageCard',{scopedSlots:_vm._u([{key:"card-title",fn:function(){return [_vm._v(" Inventory ")]},proxy:true}])},[_c('b-table',{staticClass:"table-head-custom table-vertical-center",attrs:{"items":_vm.item,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }